module.exports = __webpack_public_path__ + "static/img/video.05f28ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video.png
// module id = BXki
// module chunks = 18